<app-toast-item
	*ngFor="let toast of toasts; trackBy: trackToast"
	[@toastAnimation]
	[toastType]="toast.data.type"
	[toastTitle]="toast.data.title"
	[toastMessage]="toast.data.message"
	[toastDuration]="toast.data.duration"
	[toastAction]="toast.data.action || null"
	(actionInvoked)="runToastAction(toast)"
	(closeToast)="removeToast(toast.id)"
></app-toast-item>
